import * as helpers_1 from '@turf/helpers'
import { FeatureCollection } from '@turf/helpers'
import { getGeom } from '@turf/invariant'
import { Feature, MultiPolygon, Polygon } from 'geojson'
import polygonClipping from 'polygon-clipping'

// using the union function from @turf/union 6.2.0, but copied here b/c of test errors
function union(
  poly1: Feature<Polygon | MultiPolygon> | Polygon | MultiPolygon,
  poly2: Feature<Polygon | MultiPolygon> | Polygon | MultiPolygon,
  options?: any
) {
  if (options === void 0) {
    options = {}
  }
  var geom1 = getGeom(poly1)
  var geom2 = getGeom(poly2)
  var unioned = polygonClipping.union(geom1.coordinates as any, geom2.coordinates as any)
  if (unioned.length === 0) return null
  if (unioned.length === 1) return helpers_1.polygon(unioned[0], options.properties)
  else return helpers_1.multiPolygon(unioned, options.properties)
}

/**
 * Given a FeatureCollection, union all Polygon or MultiPolygon Features into a single Polygon | MultiPolygon
 * @param featureCollection FeatureCollection
 * @returns Polygon | MultiPolygon | undefined
 */
export const mergeFeatureCollection = (
  featureCollection: FeatureCollection<Polygon | MultiPolygon>
): Feature<Polygon | MultiPolygon> | undefined => {
  if (!featureCollection.features?.length) return

  return featureCollection.features.reduce(
    (acc: Feature<Polygon | MultiPolygon>, feature: Feature<Polygon | MultiPolygon>) => {
      try {
        const nextUnion = union(acc, feature)

        return nextUnion || acc || feature
      } catch (e) {
        console.error(e)

        return acc || feature
      }
    }
  )
}
